<template>
    <div>
        <h3 class="m-b-30 text-center">Em que cidade e bairro você pretende alugar?</h3>

        <div class="account-content">
            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('fk_city')}">
                        <label for="city" class="h5 m-b-10 control-label">Cidade</label>
                        <search-autocomplete
                            name="location"
                            ref="location"
                            id="roommate_form_location"
                            classname="form-control"
                            placeholder=""
                            v-model="form.location"
                            :params="{ types: ['city'] }"
                            @input="form.fk_city = form.fk_district = null; form.address = ''"
                            @placechanged="getCity">
                        </search-autocomplete>
                        <span class="help-block text-left" v-show="errors.has('fk_city')">
                            <strong>{{ errors.first('fk_city') }}</strong>
                        </span>
                    </div>
                </div>

                <div class="col-xs-12 m-t-15">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('fk_district')}">
                        <label class="h5 m-b-10 control-label">Preencha no campo abaixo o bairro onde você deseja alugar.</label>
                        <search-autocomplete
                            name="district"
                            ref="district"
                            id="district"
                            classname="form-control"
                            placeholder=""
                            v-model="form.address"
                            :params="{ fk_city: form.fk_city, types: ['district'] }"
                            @input="form.fk_district = null"
                            @placechanged="getDistrict">
                        </search-autocomplete>
                        <span class="help-block text-left" v-show="errors.has('fk_district')">
                            <strong>{{ errors.first('fk_district') }}</strong>
                        </span>
                    </div>
                </div>

                <div v-if="form.location && !show_map" class="col-xs-12">
                    <p>Ou <a href="#" @click.prevent="initMap()" class="text-link">clique aqui</a> para selecionar a região de sua preferência no mapa.</p>
                </div>
                <div v-show="show_map" class="col-xs-12 m-t-15">
                    <div id="rmfm_location_map" style="height: 350px"></div>
                </div>

                <div class="col-xs-12 m-t-30">
                    <button @click="submit()" class="btn btn-bordered btn-success waves-effect waves-light w-lg ladda-button pull-right" type="submit">Continuar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { load } from '../../../../../../legacy/node_modules/@zaichaopan/load-script';
export default {
    props: ['obj'],
    data() {
        return {
            map: null,
            marker: null,
            city_bounds: null,
            show_map: false,
            map_dragged: false,
            form: this.obj
        }
    },
    methods: {
        async initMap(type = 'location') {
            this.show_map = true;
            let _this = this;

            var zoom = 11;

            let google = await load({
                src: 'https://maps.googleapis.com/maps/api/js',
                callbackName: 'callback',
                resolve: 'google',
                params: {
                    key: 'AIzaSyDktD8mnJkH5PDy_k0PdtRz_L7QzpWlwtY',
                    libraries: 'places',
                    v: '3'
                }
            });

            let position = {lat: parseFloat(this.form.lat), lng: parseFloat(this.form.lng)};
            this.map = new google.maps.Map(document.getElementById('rmfm_location_map'), {
				center: position,
                zoom: zoom,
                mapTypeControl: false,
                streetViewControl: false
            });

            this.marker = new google.maps.Marker({
				map: this.map,
                position: position
            });

            window.google.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
                if (type == 'location') {
                    _this.city_bounds = this.getBounds();
                }
            });

            window.google.maps.event.addListener(this.map , 'drag', function (event) {
                _this.marker.setPosition(_this.map.getCenter() );
            });

            window.google.maps.event.addListener(this.map, 'dragend', function (event) {
                let pos = _this.map.getCenter();
                _this.marker.setPosition(pos);
                _this.$validator.errors.clear();

                _this.form.lat = pos.lat();
                _this.form.lng = pos.lng();

                _this.map_dragged = true;
            });
            window.dataLayer.push({
                'event': 'gmaps_usage',
                'event_category': 'roommate_modal_form_location',
                'event_label': 'gmaps_usage',
            });
        },
        getDistrict(data) {
            this.form.has_address = true;
            this.form.address = data.value;
            this.form.fk_district = data.data.id;
        },
        getCity(location) {
            this.form = {
                city: location.value,
                fk_district: null,
                fk_city: location.data.id,
                fk_state: location.data.fk_state,
                location: location.value,
                lat: location.data.lat,
                lng: location.data.lng,
                address: '',
            };

            this.$validator.errors.clear();

            if (this.map != null) {
                let position = {lat: parseFloat(location.data.lat), lng: parseFloat(location.data.lng)};
                this.map.setCenter(position);
                this.marker.setPosition(position);
            }
        },
        geocodeDistrict() {
            let _this = this;
            return new Promise(function(resolve, reject) {
                let pos = _this.map.getCenter();
                let geocoder = new google.maps.Geocoder();
                var dist_types = ['sublocality_level_1', 'administrative_area_level_4', 'sublocality_level_2', 'postal_code', 'route'];
                var dist_candidates = [];
                window.dataLayer.push({
                    event: 'gmaps_usage',
                    event_category: 'roommate_modal_form_location',
                    event_label: 'gmaps_usage',
                });
                geocoder.geocode({latLng: _this.marker.getPosition()}, function (results, status) {
                    if (status == 'OK') {
                        for (let a = 0; a < dist_types.length; a++) {
                            let type = dist_types[a];

                            for (let i = 0; i < results.length; i++) {
                                let place = results[i];

                                for (let j = 0; j < place.address_components.length; j++) {
                                    let component = place.address_components[j];
                                    if (component.types.indexOf(type) > -1 &&
                                        component.long_name != _this.form.city &&
                                        dist_candidates.indexOf(component.long_name) == -1) {
                                            dist_candidates.push(component.long_name);
                                            break;
                                    }
                                }
                            }
                        }
                    }
                    _this.form.has_address = true;
                    _this.form.address = dist_candidates[0];
                    _this.form.lat = pos.lat();
                    _this.form.lng = pos.lng();
                    resolve();
                });
            });
        },
        async submit() {
            this.$validator.errors.clear();

            if (!this.form.address && this.map_dragged) {
                await this.geocodeDistrict();
            }

            if (!this.form.fk_city) {
                this.errors.add({
                    field: 'fk_city',
                    msg: 'Selecione uma cidade da lista de sugestões. Não conseguimos identificar a cidade preenchida.'
                });
            }
            if (!this.form.fk_district) {
                this.errors.add({
                    field: 'fk_district',
                    msg: 'Selecione um bairro da lista de sugestões.'
                });
            }
            if (this.errors.any()) {
                return;
            }

            this.$emit('submit', this.form);
            window.scrollTo(0, 0);
        },
    }
}
</script>
